import {FORM_FIELDS} from '@/constants/help/form';
import {TemplateBuilder} from '@/components/help/common/FormContainer/types';

export const INQUIRY_MAIN_CATEGORY = [
  {label: '회원 가입 ⁄ 탈퇴', value: 'NODE0000000549'},
  {label: '유저정보', value: 'NODE0000000031'},
  {label: '방송하기', value: 'NODE0000000037'},
  {label: '참여하기', value: 'NODE0000000417'},
  {label: 'VOD', value: 'NODE0000000477'},
  {label: '건의하기', value: 'NODE0000000423'},
  {label: '장애/버그', value: 'NODE0000000427'},
  {label: '아이템', value: 'NODE0000000042'},
  {label: '결제', value: 'NODE0000000047'},
  {label: '별풍선환전', value: 'NODE0000000430'},
  {label: '청소년유해물신고', value: 'NODE0000000058'},
  {label: '청소년스트리머 상담센터', value: 'NODE0000000469'},
  {label: '기타', value: 'NODE0000000062'},
];

export const INQUIRY_FIELD_ORDER = [
  FORM_FIELDS.OS_INFO,
  FORM_FIELDS.MAIN_CATEGORY,
  FORM_FIELDS.SUB_CATEGORY,
  FORM_FIELDS.EMAIL,
  FORM_FIELDS.TITLE,
  FORM_FIELDS.CONTENT,
  FORM_FIELDS.FILES,
  FORM_FIELDS.AGREEMENT,
];

const MOBILE_COMMON_CONTENT = '인터넷 정보(데이터 or Wifi):\n방송 설정 화질:';
const PC_COMMON_CONTENT = 'Windows 버전:\n브라우저 정보 및 버전:';
const INQUIRY_TAIL = '\n문의내용:\n※ 문의 참고 화면 캡쳐 자료 첨부하여 주세요.';

const commonContent = (isMobile: boolean) =>
  isMobile ? MOBILE_COMMON_CONTENT : PC_COMMON_CONTENT;

const TEMPLATES = {
  // 기본 템플릿
  BASE: (isGuest: boolean) =>
    `[아래 정보를 입력하여 문의를 주시면 정확한 확인 후 답변이 가능합니다.]\n\n${
      isGuest ? '아이디:\n' : ''
    }`,

  // 공통으로 사용되는 템플릿
  NAME_AND_INQUIRY: `성함:\n문의내용:`,
  TECH_SUPPORT: (isMobile: boolean) => commonContent(isMobile) + INQUIRY_TAIL,
  VOD_SUPPORT: (isMobile: boolean) => commonContent(isMobile) + INQUIRY_TAIL,
  DETAILED_INQUIRY: (isGuest: boolean) =>
    `[문의 내용을 상세하게 기재하여 주세요.]\n${isGuest ? '아이디:\n' : ''}`,

  // 특정 유형 템플릿
  SUGGESTION: '[건의하고자 하신 내용을 상세하게 기재하여 주세요.]\n',
  REPORT_USER: (isMobile: boolean) =>
    isMobile
      ? '스트리머 및 유저가 운영정책을 위반하는 행위를 목격할 경우 신속, 정확한 확인을 위해 위반대상 아이디 또는 닉네임, 발생일시, 위반 내용을 기재해주시면 감사하겠습니다.\n건강한 커뮤니티 생태계를 만들기 위해 노력하겠습니다.'
      : '[운영정책 위반 행위가 발생된 유저 아이디 또는 닉네임, 발생 일시, 위반 내용을 상세히 기재하여 주세요.]\n',
  BUG_REPORT: (isMobile: boolean) =>
    [
      ...(isMobile
        ? [
            '인터넷 정보(데이터 or Wifi):',
            '서비스 이용 시 화질 정보:',
            '앱 삭제 후 재설치 여부(Y/N):',
            '오류 발생 경로:',
          ]
        : [
            'PC/모바일:',
            'PC의 경우 플레이어 정보 기재:',
            '(EX) 프릭샷 or 기존 스튜디오)',
            '모바일의 경우 OS정보 및 앱 버전 기재:',
            '(EX) 안드로이드 or IOS)',
            '플레이어 삭제후 재설치 여부(Y/N):',
            '앱 삭제후 재설치 여부(Y/N):',
            '장애 또는 버그 내용:',
          ]),
      '※ 오류 발생 화면 캡쳐 후 첨부하여 주세요.',
    ].join('\n'),
  PAYMENT_REFUND: [
    '성함:',
    '문의 내용:',
    '',
    '※ 결제 내역 화면 캡쳐 후 첨부하여 주세요',
    '※ 결제 취소 및 환불의 경우 PC를 통한 직접 신청이 가능하며,',
    '아래 경로를 통해 진행 시 보다 신속하게 처리 가능합니다.',
    '',
    '[결제취소]',
    'PC > 로그인 후 오른쪽 상단 프로필 > 별풍선 > 내 선물·후원 정보 > 오른쪽 결제 내역 > 비밀번호 입력 > 취소',
    '',
    '[환불]',
    'PC > 로그인 후 오른쪽 상단 프로필 > 별풍선 > 내 선물·후원 정보 > 오른쪽 결제 내역 > 비밀번호 입력 > 우측 하단 환불하기',
  ].join('\n'),
  STREAM_JOIN: (isMobile: boolean) =>
    commonContent(isMobile) +
    (isMobile ? '' : '\n캐시 및 쿠키 삭제 여부(Y/N):') +
    INQUIRY_TAIL,
};

export const INQUIRY_TEMPLATE_MAP = new Map<string, TemplateBuilder>([
  [
    //회원가입/탈퇴
    'NODE0000000549',
    ({isGuest}) => `${TEMPLATES.BASE(isGuest)}${TEMPLATES.NAME_AND_INQUIRY}`,
  ],
  [
    //유저정보
    'NODE0000000031',
    ({isGuest}) => `${TEMPLATES.BASE(isGuest)}${TEMPLATES.NAME_AND_INQUIRY}`,
  ],
  [
    //아이템
    'NODE0000000042',
    ({isGuest}) => `${TEMPLATES.BASE(isGuest)}${TEMPLATES.NAME_AND_INQUIRY}`,
  ],
  [
    //별풍선환전
    'NODE0000000430',
    ({isGuest}) => `${TEMPLATES.BASE(isGuest)}${TEMPLATES.NAME_AND_INQUIRY}`,
  ],
  [
    //결제
    'NODE0000000047',
    ({isGuest}) => `${TEMPLATES.BASE(isGuest)}${TEMPLATES.PAYMENT_REFUND}`,
  ],

  [
    //방송하기
    'NODE0000000037',
    ({isGuest, isMobile}) =>
      `${TEMPLATES.BASE(isGuest)}${TEMPLATES.TECH_SUPPORT(isMobile)}`,
  ],
  [
    //참여하기
    'NODE0000000417',
    ({isGuest, isMobile}) =>
      `${TEMPLATES.BASE(isGuest)}${TEMPLATES.STREAM_JOIN(isMobile)}`,
  ],
  [
    //VOD
    'NODE0000000477',
    ({isGuest, isMobile}) =>
      `${TEMPLATES.BASE(isGuest)}${TEMPLATES.VOD_SUPPORT(isMobile)}`,
  ],

  //건의하기
  ['NODE0000000423', () => TEMPLATES.SUGGESTION],
  [
    //장애/버그
    'NODE0000000427',
    ({isGuest, isMobile}) =>
      `${TEMPLATES.BASE(isGuest)}${TEMPLATES.BUG_REPORT(isMobile)}`,
  ],
  //청소년유해물신고
  ['NODE0000000058', ({isMobile}) => TEMPLATES.REPORT_USER(isMobile)],

  //청소년스트리머 상담센터
  ['NODE0000000469', () => '[문의 내용을 상세하게 기재하여 주세요.]'],
  // '기타'
  [
    'NODE0000000062',
    ({isGuest}) => `${TEMPLATES.DETAILED_INQUIRY(isGuest)}문의내용:`,
  ],
]);

// 문의하기 페이지 > content placeholder
export const INQUIRY_DEFAULT_TEMPLATE = `문의 내용을 상세하게 기재하여 주세요.
\n※ 개인정보 보호를 위해 신분증과 같은 개인정보 항목을 첨부하실 경우,\n   주민등록번호 뒷자리가 노출되지 않도록 첨부 해주시기 바랍니다.`;
